module.exports = __webpack_public_path__ + "static/media/chart.c6d7395e.svg";